import React from 'react'
import Alert from '@mui/material/Alert'

import { FEEDBACK_ALERT_DURATION_MS } from './constants/feedbackAlertConstants'
import {
  buildFeedbackAlertSx,
  resolveFeedbackAlertIcon,
  resolveFeedbackAlertStyle
} from './helpers/feedbackAlertHelpers'

const FeedbackAlert = React.forwardRef(function FeedbackAlert(
  {
    id,
    message,
    severity = 'error',
    icon,
    colors,
    onClose,
    className,
    sx,
    durationMs = FEEDBACK_ALERT_DURATION_MS
  },
  ref
) {
  if (!message) return null

  const style = resolveFeedbackAlertStyle(severity, colors)
  const alertSx = sx || buildFeedbackAlertSx(style, durationMs)

  return (
    <Alert
      ref={ref}
      key={id}
      severity={severity}
      icon={resolveFeedbackAlertIcon(severity, icon)}
      onClose={onClose}
      className={className}
      sx={alertSx}
    >
      {message}
    </Alert>
  )
})

export default FeedbackAlert
